var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMn9VwcisXzgowe7(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.99965 12.6005C8.47465 12.6005 7.94965 12.398 7.55215 12.0005L2.66215 7.11047C2.44465 6.89297 2.44465 6.53297 2.66215 6.31547C2.87965 6.09797 3.23965 6.09797 3.45715 6.31547L8.34715 11.2055C8.70715 11.5655 9.29215 11.5655 9.65215 11.2055L14.5421 6.31547C14.7596 6.09797 15.1196 6.09797 15.3371 6.31547C15.5546 6.53297 15.5546 6.89297 15.3371 7.11047L10.4471 12.0005C10.0496 12.398 9.52465 12.6005 8.99965 12.6005Z",
    fill: "white",
    fillOpacity: 0.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMn9VwcisXzgowe7);
export default __webpack_public_path__ + "static/media/mn9vwcis-xzgowe7.9194e966ed454358bce2a5c8e6cb2023.svg";
export { ForwardRef as ReactComponent };